import React from 'react';

import { useMutateKaiAssistants } from '@hooks/kaiAssistants/useMutateKaiAssistants';

import KaiAssistantForm from '../KaiAssistantForm';
import { ISubmitHandlerProps } from '../KaiAssistantForm/KaiAssistantForm';

export default function CreateKaiAssistant({
	organizationId,
	close,
}: {
	organizationId: string;
	close: () => void;
}) {
	const {
		createKaiAssistant,
		isCreatingKaiAssistant,
	} = useMutateKaiAssistants();

	const handleCreateKaiAssistant = async (data: ISubmitHandlerProps) => {
		await createKaiAssistant({
			name: data.name,
			kaiId: data.kaiId,
			organizationId,
			userIds: data.userIds,
		});
	};

	return (
		<KaiAssistantForm
			close={close}
			isLoading={isCreatingKaiAssistant}
			organizationId={organizationId}
			submitHandler={handleCreateKaiAssistant}
		/>
	);
}
